import React, { useState,useRef, useEffect } from "react";
import "../styles/Faqs.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";


const ComFaqs = ({dtfaqs})=>{
    const [openIndex, setOpenIndex] = useState(null);
  
    const toggleAccordion = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };
    const itemRefs = useRef([]);
    useEffect(() => {
      // Scroll to the opened accordion item
      if (openIndex !== null && itemRefs.current[openIndex]) {
      const offset = -250; // Adjust this value for desired spacing from top
      const elementPosition = itemRefs.current[openIndex].getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition + offset,
        behavior: 'smooth',
      });
      }
    }, [openIndex]);
    if(dtfaqs)
    return(
    <>
 <div className="mx-auto md:px-8 w-full min-h-full header"> FAQs </div>
<div className="space-y-4 body">
      {dtfaqs.map((item, index) => (
        <div key={index} className="border border-gray-300 rounded-md"
       
        >
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full text-left px-4 py-2 font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            {item.title}
            <span className="text-xl accIcon">
              {openIndex === index ? '-' : '+'}
            </span>
          </button>
          {openIndex === index && (
            <div className="px-4 py-2 text-gray-600 bg-white border-t border-gray-300"  
            ref={(el) => (itemRefs.current[index] = el)}
            dangerouslySetInnerHTML={{ __html: item.content }}/>
          )}
        </div>
      ))}
    </div>
  
    </>
   
    );
}

export default ComFaqs;